// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table.table[data-v-01fd5849] {\n  margin-left: 2em;\n}\ntd.center[data-v-01fd5849] {\n  text-align: center;\n}\ntd.v-align-middle[data-v-01fd5849] {\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
